const DEFAULT_COUNTRY = 'de';
const DEFAULT_LANGUAGE = 'en';
const DEFAULT_CURRENCY = 'eur';
const DEFAULT_BILLING_PERIOD = 'Month';
const DEFAULT_PRICE = 9.99;

export {
    DEFAULT_COUNTRY,
    DEFAULT_LANGUAGE,
    DEFAULT_CURRENCY,
    DEFAULT_BILLING_PERIOD,
    DEFAULT_PRICE
};
